import { ValidatorFn, FormGroup } from '@angular/forms';

export const SenhaNaoEConfirmacao: ValidatorFn = (form: FormGroup) => {
  if(!form.get("Senha").value || !form.get("ConfirmaSenha").value)
    return null;
  return form.get("Senha").value !== form.get("ConfirmaSenha").value ? {SenhaNaoEConfirmacao:"A senha é diferente da de confirmação"} : null;
};
